module.exports = __webpack_public_path__ + "static/media/roster-to-practice.10fc3573.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/roster-to-practice.mov
// module id = 621
// module chunks = 0